import React, { useState, useEffect } from "react";
import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ContactsIcon from "@mui/icons-material/Contacts";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentNeutralOutlinedIcon from "@mui/icons-material/SentimentNeutralOutlined";
import SentimentSatisfiedOutlinedIcon from "@mui/icons-material/SentimentSatisfiedOutlined";
import { getDashboardData } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import CircularLoader from "../../Track_Website/CircularLoader";

const Dashboard = () => {
  const [showAllUsers, setShowAllUsers] = useState(false);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [loading, setLoading] = useState(false);
  const { AllDashboardData, setAllDashboardData,totalDetails, setTotalDetails } = useWorkspace();
  const [data, setData] = useState([])

  useEffect(() => {
    if (!showAllUsers && AllDashboardData) {
      const slicedData = AllDashboardData.slice(0, 3);
      setData(slicedData);
    } else {
      setData(AllDashboardData);
    }
  }, [showAllUsers, AllDashboardData]);



  const HandleViewAllButtonClick = () => {
    setShowAllUsers(true);
    setData(AllDashboardData);
  };

  const HandleViewLessButtonClick = () => {
    setShowAllUsers(false);
    const slicedData = AllDashboardData.slice(0, 3);
    setData(slicedData);
  };

  useEffect(() => {
    if (!AllDashboardData) {
      setLoading(true);
      getDashboraddata();
    }
  }, []);

  const getDashboraddata = async () => {
    try {
      const jsonResponse = await getDashboardData();
      const DashboardData = await jsonResponse.json();
      if (DashboardData?.status) {
        // console.log("DashboardData", DashboardData?.data)
        setAllDashboardData(DashboardData?.data?.recent_sessions);
        setTotalDetails(prev=>({...prev, totalContact:DashboardData?.data?.total_contacts, totalLLMAgent: DashboardData?.data?.llm_agents_count,  totalVoiceAgent : DashboardData?.data?.voice_agents_count, totalPhoneNumber : DashboardData?.data?.phone_numbers_count}))
      } else {
        setOpen(true);
        setContent(DashboardData?.message);
        setIconType("error");
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
      setContent(error?.message);
      setIconType("error");
    }
    setLoading(false);
  };

  const handleToastClose = () => {
    setOpen(false);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
  
    const day = date.getDate();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
  
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
  
    return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  }

  return (
    <div>
      <Typography variant="h4" sx={{marginBottom: "40px" , fontFamily:"Inter", fontSize:"24px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", color:"#ffffff", opacity:0.90}}>
        Dashboard
      </Typography>
      {/* Dashboard content goes here */}
      <Grid container spacing={5} justifyContent="center">
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Total Contacts
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalDetails?.totalContact}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <ContactsIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Voice Agents
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalDetails?.totalVoiceAgent}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <GraphicEqIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                LLM Agents
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalDetails?.totalLLMAgent}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <VoiceChatIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Phone numbers
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {totalDetails?.totalPhoneNumber}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <LocalPhoneIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.10)",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#171A2D",
          marginTop: "60px",
          padding: "20px",
          borderRadius: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            backgroundColor: "#171A2D",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "16px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
                color: "rgba(255, 255, 255, 0.80)",
              }}
            >
              Recent Sessions
            </Typography>
            <Button
              onClick={
                showAllUsers
                  ? HandleViewLessButtonClick
                  : HandleViewAllButtonClick
              }
              sx={{
                fontFamily: "Inter",
                color: "#ffffff",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
                textTransform: "none",
                '&:hover':{
                  color:"#FFFFFF",
                  opacity:0.80
                }
              }}
            >
              {showAllUsers ? "View less" : "View all"}
            </Button>
          </Box>

          <Box>
            {loading ? (
              <CircularLoader  msg={"Loading Dashboard..."} /> 
            ) : (
              <TableContainer>
                <Table
                  sx={{
                    fontFamily: "Inter",
                    color: "#ffffff",
                    padding: "20px 24px",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Session ID
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Contact name
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Type
                      </TableCell>
                      {/* <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        From Number
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        To Number
                      </TableCell> */}
                       <TableCell
                                            align="left"
                                            sx={{
                                                fontFamily: "Inter",
                                                color: "#ffffff",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "28px",
                                                padding: "16px 10px",
                                                borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                                                minWidth:"120px"
                                                }}>
                                            Call from/to
                                          </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Duration(Sec)
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Sentiment
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "28px",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Created at
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((row, index) => (
                      <TableRow
                        key={row?.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.session_id
                            ? `${row.session_id.split("").slice(0, 20).join("")}...`
                            : ""}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.name}
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          <Tooltip placement="bottom"
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -10], // [horizontal, vertical] — reduce vertical gap (default is usually 14)
                                },
                              },
                            ],
                          }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                    bgcolor: "#E6E0E9",
                                    color: "#17182C",
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    padding: "4px 8px 4px 8px",
                                    borderRadius: "4px",
                                    textAlign: "center",
                                    },
                                },
                            }}
                            title={`${row?.direction}`}
                          >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              columnGap: "10px",
                              width: "120px",
                              height: "36px",
                              backgroundColor: "#1F233E",
                              padding: "6px",
                              borderRadius: "8px",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box sx={{}}>
                              {row?.type === "web_call" ? (
                                <LanguageIcon
                                  width="16px"
                                  height="16px"
                                  sx={{ color: "#CAC4D0" }}
                                />
                              ) : (
                                <LocalPhoneIcon
                                  width="16px"
                                  height="16px"
                                  sx={{ color: "#CAC4D0" }}
                                />
                              )}
                            </Box>
                            <Box
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                fontSize: "14px",
                              }}
                            >
                              {row?.type}
                            </Box>
                          </Box></Tooltip>
                        </TableCell>
                        {/* <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.from_number}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.to_number}
                        </TableCell> */}
                         <TableCell
                                                align="left"
                                                sx={{
                                                  fontFamily: "Inter",
                                                  color: "#ffffff",
                                                  fontSize: "14px",
                                                  fontStyle: "normal",
                                                  fontWeight: 400,
                                                  lineHeight: "28px",
                                                  padding: "16px 10px",
                                                  borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                                                  minWidth: "120px",
                                                }}
                                              >
                                               {/* {`From: ${row?.from_number} To: ${row?.to_number}`} */}
                                               {row?.from_number || row?.to_number
                                              ? `${row?.from_number ? `From: ${row.from_number}` : ''}${row?.to_number ? ` To: ${row.to_number}` : ''}`
                                              : row?.type == "web_call" ? "Web call" : 'N/A'}
                                              </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                             {`${row?.duration/ 1000}`}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row.sentiment === "Positive" ? (
                            <SentimentSatisfiedOutlinedIcon
                              sx={{ color: "#23A565" }}
                            />
                          ) : row.sentiment === "Neutral" ? (
                            <SentimentNeutralOutlinedIcon
                              sx={{ color: "#EED680" }}
                            />
                          ) :  row.sentiment === "Negative" ? (
                            <SentimentDissatisfiedOutlinedIcon
                              sx={{ color: "#DD2025" }}
                            />
                          ) : null
                        }
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "28px",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {formatDateTime(row.created_at)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </Box>
      </Box>
      <CommonToast
        open={open}
        onClose={handleToastClose}
        content={content}
        iconType={iconType}
        bgColor={"#282D51"}
      />
    </div>
  );
};

export default Dashboard;
